import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Reports_custom_ds_get_outbound_last_load_survey_advancedService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async get($inParams: { order_id: number }): Promise<{ result?: { Contents?: { QA?: { Questions?: string, Responses?: string }[] }, SurveyDefinitionName?: string, OperationTypeName?: string, EquipmentName?: string, LoadContainerLookupCode?: string, EntityName?: string, CreatedSysUser?: string } }> {
    const $missingRequiredInParams = [];
    if (isNil($inParams.order_id)) {
      $missingRequiredInParams.push('\'order_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

    
    hasMissingRequiredInParams($inParams: { 
      order_id: number    }) {
        if(isNil($inParams.order_id)) {
          return true; 
        }
      return false;
    }
}
